import api from "./index";

export interface LearningRequestsListParams {
  number?: string;
  companyId?: string;
  responsibleId?: string;
  courseId?: string;
  courseTitle?: string;
  categoryId?: string;
  contractorId?: string;
  contractorType?: "juridical" | "physical";
  clientType?: string;
  clientId?: string;
  resourceType?: string;
  resourceId?: string;
  priceMin?: number;
  priceMax?: number;
  status?:
    | "not_processed"
    | "waiting_payment"
    | "learning"
    | "learning_finished"
    | "documents_ready"
    | "completed"
    | "cancelled";
  formedAtMin?: Date;
  formedAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  sort?: "createdAt" | "updatedAt" | "formedAt" | "number";
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: LearningRequestsListParams) => {
  return api.LearningRequestApi.listShort(
    params.number,
    params.companyId,
    params.responsibleId,
    params.courseId,
    params.courseTitle,
    params.categoryId,
    params.contractorId,
    params.contractorType,
    params.clientType,
    params.clientId,
    params.resourceType,
    params.resourceId,
    params.priceMin,
    params.priceMax,
    params.status,
    params.formedAtMin,
    params.formedAtMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.sort,
    params.order,
    params.offset,
    params.limit,
    params.options
  );
};
